import LogoutIcon from '@mui/icons-material/Logout';
import { Avatar, Box, Chip, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import React from 'react';
import type { RegistrySession } from './RegistrySession';

function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]!.toUpperCase())
    .join('');
}

/** The signed-in admin and the registry permissions the backend says they hold. */
export default function SignedInBadge({ session }: { session: RegistrySession }) {
  const { user, permissions } = session.me;
  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      aria-label="Signed-in user"
      sx={{ minWidth: 0 }}
    >
      <Avatar sx={{ width: 28, height: 28, fontSize: '0.75rem', bgcolor: 'primary.main' }}>
        {initials(user.name)}
      </Avatar>
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="body2" sx={{ fontWeight: 600, lineHeight: 1.2 }}>
          {user.name}
        </Typography>
        <Stack
          useFlexGap
          direction="row"
          spacing={0.5}
          sx={{ flexWrap: 'wrap', rowGap: 0.5, mt: 0.25 }}
          aria-label="Registry permissions"
        >
          {permissions.map((permission) => (
            <Chip
              key={permission.id}
              size="small"
              variant="outlined"
              label={permission.name.replace(/^Registry /, '')}
              sx={{ height: 18, fontSize: '0.68rem' }}
            />
          ))}
        </Stack>
      </Box>
      <Tooltip title="Sign out">
        <IconButton size="small" aria-label="Sign out" onClick={session.signOut}>
          <LogoutIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Stack>
  );
}
